import { patchState, signalStore, withMethods, withState } from '@ngrx/signals';

interface UpdateDataProps {
  locale?: 'en' | 'fr';
}
interface DataState {
  isLoading: boolean;
  locale: 'en' | 'fr';
}

export const initialValue: DataState = {
  isLoading: true,
  locale: 'en',
};

export const DataStore = signalStore(
  { providedIn: 'root' },
  withState(initialValue),
  withMethods(({ ...store }) => ({
    setData: ({ locale }: UpdateDataProps) => {
      patchState(store, {
        locale: locale ?? store.locale(),
        isLoading: false,
      });
    },
  })),
);
